export const routes = (prefix = `med-f-print`) => [
    {
        path: `/${prefix}/:patientID/:visitNo`,
        name: `${prefix}.index`,
        component: () => import('./MedicalFile.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
        },
    },
    {
        path: `/${prefix}/prescriptions-orders/print/:patientID/:visitNo`,
        name: `${prefix}.prescriptions-orders.print`,
        component: () => import('./PrescriptionOrderToday.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    }, {
        path: `/${prefix}/medical-report/print/:patientID/:visitNo/:doctor/:date`,
        name: `${prefix}.medical-report.print`,
        component: () => import('./MedicalReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    },{
        path: `/${prefix}/consultant-request/print/:patientID/:visitNo/:consultantrequestId`,
        name: `${prefix}.prescriptions-orders.print`,
        component: () => import('./ConsultationRequest.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
            print: true,
        },
    }, {
        path: `/${prefix}/gamka/print/:patientID/:visitNo`,
        name: `${prefix}.index`,
        component: () => import('./gamka.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
        },
    },
];
